import React from "react";
import { normalizeName } from "../../../lib/wowHelpers";
import { CLASSES_AND_SPECS } from "../../../lib/classes-and-specs";

function toUrlSafe(str: string) {
  return str.toLowerCase().split(" ").join("_");
}

interface ClassContainerProps {
  details: (typeof CLASSES_AND_SPECS)[number];
}

const ClassContainer = (props: ClassContainerProps) => {
  const { details } = props;
  return (
    <div className="class-container">
      <div className="title">
        <img src={`https://static.bigbrain.gg/wow/icons/${details.icon}.png`} alt={details.class} />
        <h3 style={{ color: details.color }}>{details.class}</h3>
      </div>
      {details.specs.map((spec) => {
        return (
          <a href={`/wow/${toUrlSafe(spec.title)}/${toUrlSafe(details.class)}/talents`} key={spec.title}>
            <div className="spec-container">
              <img
                src={`https://static.bigbrain.gg/wow/spec-icons/${normalizeName(details.class)}-${normalizeName(spec.title)}.jpg`}
              />
              <p className="spec-title">{spec.title}</p>
            </div>
          </a>
        );
      })}
    </div>
  );
};

export default ClassContainer;
